import { Theme } from '@theme'
import { StyleSheet } from 'react-native'

export default (theme: Theme, top: number) =>
  StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingTop: top + theme.spacing.xxl,
      paddingBottom: theme.spacing.xxxl,
    },
    topContainer: {
      flex: 1,
      width: '100%',
      alignItems: 'center',
    },
    iconApp: {
      width: 110,
      height: 110,
    },
    keeptouchTitle: {
      paddingTop: theme.spacing.lg,
      fontSize: 36,
    },
    bottomContainer: {
      flex: 1,
      width: '100%',
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingHorizontal: theme.spacing.xl,
    },
    registerButton: {
      marginVertical: theme.spacing.xl,
    },
    bottomText: {
      textAlign: 'center',
    },
    languageRow: {
      flexDirection: 'row',
      justifyContent: 'center',
      marginTop: theme.spacing.md,
    },
    languageLink: {
      paddingVertical: theme.spacing.xs,
      paddingHorizontal: theme.spacing.sm,
    },
    // Web : petit cadre translucide sombre derrière le slogan (blanc sur fond clair
    // sinon illisible).
    sloganFrame: {
      backgroundColor: 'rgba(7,11,45,0.45)',
      borderRadius: theme.border.medium,
      paddingVertical: theme.spacing.sm,
      paddingHorizontal: theme.spacing.lg,
      marginTop: theme.spacing.xs,
      alignSelf: 'center',
    },
  })
